"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAffordableIncomeSourceData = exports.affordableIncomeSourceFormRules = exports.affordableIncomeSourceSchema = exports.validateAffordableIncomeEmployerData = exports.affordableIncomeEmployerFormRules = exports.affordableIncomeEmployerSchema = void 0;
const amount_utils_1 = require("../../amount-utils");
const converters_1 = require("../../converters");
const income_1 = require("./income");
const validateHourPerWeek = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0 && numValue <= 168;
    }
    return true;
};
const validateWeekPerYear = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0 && numValue <= 52;
    }
    return true;
};
const validateHourlyWage = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0;
    }
    return true;
};
exports.affordableIncomeEmployerSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
        hour_per_week: {
            required: false,
            custom: {
                validate: validateHourPerWeek,
                message: 'Hours per week must be between 1 and 168',
            },
        },
        week_per_year: {
            required: false,
            custom: {
                validate: validateWeekPerYear,
                message: 'Weeks per year must be between 1 and 52',
            },
        },
        hourly_wage: {
            required: false,
            custom: {
                validate: validateHourlyWage,
                message: 'Hourly wage must be greater than 0',
            },
        },
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Income Source must be 200 characters or less',
        },
        contact_name: {
            maxLength: 'Contact Name must be 50 character or less',
        },
        amount: {
            required: 'Salary/Wage is required',
            min: 'Salary/Wage must be greater than 0',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.affordableIncomeEmployerFormRules = (0, converters_1.toReactHookForm)(exports.affordableIncomeEmployerSchema, income_1.incomeFieldMapping);
exports.validateAffordableIncomeEmployerData = (0, converters_1.createValidator)(exports.affordableIncomeEmployerSchema);
exports.affordableIncomeSourceSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
        hour_per_week: {
            required: false,
            custom: {
                validate: validateHourPerWeek,
                message: 'Hours per week must be between 1 and 168',
            },
        },
        week_per_year: {
            required: false,
            custom: {
                validate: validateWeekPerYear,
                message: 'Weeks per year must be between 1 and 52',
            },
        },
        hourly_wage: {
            required: false,
            custom: {
                validate: validateHourlyWage,
                message: 'Hourly wage must be greater than 0',
            },
        },
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Income Source must be 200 characters or less',
        },
        contact_name: {
            maxLength: 'Supervisor Name must be 50 character or less',
        },
        contact_phone: {
            maxLength: 'Supervisor Phone must be 10 character or less',
        },
        contact_email: {
            maxLength: 'Supervisor Email must be 50 character or less',
        },
        contact_fax: {
            maxLength: 'Supervisor Fax must be 10 character or less',
        },
        amount: {
            required: 'Salary/Wage is required',
            min: 'Salary/Wage must be greater than 0',
        },
    },
};
exports.affordableIncomeSourceFormRules = (0, converters_1.toReactHookForm)(exports.affordableIncomeSourceSchema, income_1.incomeFieldMapping);
exports.validateAffordableIncomeSourceData = (0, converters_1.createValidator)(exports.affordableIncomeSourceSchema);
